var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.createdMode)?_c('create-role-form',{on:{"cancel":function($event){_vm.createdMode = false},"success":_vm.showSuccess,"error":_vm.showError}}):_c('role-table',{ref:"table",on:{"add-role":function($event){_vm.createdMode = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }